module.exports = __webpack_public_path__ + "static/media/Logo.50fe0d7d.png";